"use client";

import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const BookingApp = dynamic(() => import("./BookingApp"), { ssr: false });

export default function BookingAppRouteGate() {
  const router = useRouter();

  if (!router.isReady) {
    return null;
  }

  const path = router.asPath.split("?")[0] || "";

  const normalizedPath = path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path;
  const isServicesPath = normalizedPath === "/services" || normalizedPath.startsWith("/services/");

  if (!isServicesPath) {
    return null;
  }

  return <BookingApp />;
}
